import { motion } from 'framer-motion';
import { useInView } from 'react-intersection-observer';

const About = () => {
  const [ref, inView] = useInView({
    triggerOnce: true,
    threshold: 0.1,
  });

  const fadeIn = {
    hidden: { opacity: 0, y: 20 },
    visible: { opacity: 1, y: 0 },
  };

  return (
    <section id="about" className="section bg-white">
      <div className="container">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
          <motion.div
            ref={ref}
            initial="hidden"
            animate={inView ? 'visible' : 'hidden'}
            variants={fadeIn}
            transition={{ duration: 0.6 }}
            className="relative"
          >
            <div className="relative z-10 overflow-hidden rounded-lg shadow-xl">
              <img
                src="/images/Screenshot 2025-04-02 083909.png"
                alt="Premium deck craftsmanship detail"
                className="w-full h-auto object-cover"
                style={{ height: '500px' }}
              />
            </div>
            <div className="absolute -bottom-6 -right-6 w-48 h-48 bg-primary rounded-lg z-0"></div>
            <div className="absolute -top-6 -left-6 w-32 h-32 bg-secondary rounded-lg z-0"></div>
          </motion.div>

          <motion.div
            ref={ref}
            initial="hidden"
            animate={inView ? 'visible' : 'hidden'}
            variants={fadeIn}
            transition={{ duration: 0.6, delay: 0.2 }}
          >
            <div className="mb-6">
              <h2 className="section-title">Crafting Outdoor Excellence Since 2005</h2>
              <div className="w-20 h-1 bg-primary mb-6"></div>
            </div>
            <p className="text-lg mb-6">
              At Decks and Pergolas, we specialize in creating stunning outdoor living spaces that blend seamlessly with your home's architecture while providing functional areas for relaxation and entertainment.
            </p>
            <p className="text-lg mb-6">
              Our team of skilled craftsmen brings over 20 years of experience to every project, ensuring meticulous attention to detail and uncompromising quality. We work closely with each client to understand their vision, preferences, and lifestyle needs.
            </p>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-8">
              <div className="flex items-start">
                <div className="flex-shrink-0 mr-4">
                  <div className="w-10 h-10 bg-accent rounded-lg flex items-center justify-center text-white">
                    <svg
                      className="w-6 h-6"
                      fill="none"
                      stroke="currentColor"
                      viewBox="0 0 24 24"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth={2}
                        d="M5 13l4 4L19 7"
                      />
                    </svg>
                  </div>
                </div>
                <div>
                  <h3 className="text-xl font-bold mb-2">Premium Materials</h3>
                  <p>We use only the highest quality materials sourced from sustainable suppliers.</p>
                </div>
              </div>
              <div className="flex items-start">
                <div className="flex-shrink-0 mr-4">
                  <div className="w-10 h-10 bg-accent rounded-lg flex items-center justify-center text-white">
                    <svg
                      className="w-6 h-6"
                      fill="none"
                      stroke="currentColor"
                      viewBox="0 0 24 24"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth={2}
                        d="M5 13l4 4L19 7"
                      />
                    </svg>
                  </div>
                </div>
                <div>
                  <h3 className="text-xl font-bold mb-2">Expert Craftsmanship</h3>
                  <p>Our skilled team delivers exceptional construction and attention to detail.</p>
                </div>
              </div>
              <div className="flex items-start">
                <div className="flex-shrink-0 mr-4">
                  <div className="w-10 h-10 bg-accent rounded-lg flex items-center justify-center text-white">
                    <svg
                      className="w-6 h-6"
                      fill="none"
                      stroke="currentColor"
                      viewBox="0 0 24 24"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth={2}
                        d="M5 13l4 4L19 7"
                      />
                    </svg>
                  </div>
                </div>
                <div>
                  <h3 className="text-xl font-bold mb-2">Custom Designs</h3>
                  <p>Every project is uniquely designed to match your home and preferences.</p>
                </div>
              </div>
              <div className="flex items-start">
                <div className="flex-shrink-0 mr-4">
                  <div className="w-10 h-10 bg-accent rounded-lg flex items-center justify-center text-white">
                    <svg
                      className="w-6 h-6"
                      fill="none"
                      stroke="currentColor"
                      viewBox="0 0 24 24"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth={2}
                        d="M5 13l4 4L19 7"
                      />
                    </svg>
                  </div>
                </div>
                <div>
                  <h3 className="text-xl font-bold mb-2">Lasting Satisfaction</h3>
                  <p>Our projects are built to endure and provide enjoyment for years to come.</p>
                </div>
              </div>
            </div>
            <a href="#services" className="btn btn-primary">
              Our Services
            </a>
          </motion.div>
        </div>
      </div>
    </section>
  );
};

export default About; 